class Subject {
  // 观察者列表
  observers: any[] = []

  // 添加订阅者
  add (observer: unknown): void {
    this.observers.push(observer)
  }

  // 删除...
  remove (observer: unknown): void {
    const idx = this.observers.findIndex(item => item === observer)
    idx > -1 && this.observers.splice(idx, 1)
  }

  // 通知
  notify (): void {
    for (const o of this.observers) {
      o.update()
    }
  }
}

export default Subject
